import { Language, PageContent } from "../content";
import { DesertLandscape } from "./DesertLandscape";

type HeroSectionProps = {
  copy: PageContent;
  language: Language;
  onLanguageChange: (language: Language) => void;
};

export function HeroSection({ copy, language, onLanguageChange }: HeroSectionProps) {
  return (
    <header id="top" className="hero" aria-label={copy.headerLabel}>
      <DesertLandscape />

      <div className="language-switch" aria-label={copy.languageLabel}>
        <button
          type="button"
          className={language === "en" ? "active" : ""}
          aria-pressed={language === "en"}
          onClick={() => onLanguageChange("en")}
        >
          EN
        </button>
        <button
          type="button"
          className={language === "es" ? "active" : ""}
          aria-pressed={language === "es"}
          onClick={() => onLanguageChange("es")}
        >
          ES
        </button>
      </div>

      <div className="hero-content">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h1>{copy.title}</h1>
        <p className="intro">{copy.intro}</p>
        <span className="hero-rule" aria-hidden="true" />
      </div>
    </header>
  );
}
